//This user data service will limit the amount of repetitive calls we make to the user collection (for viewing others profiles etc.). 
import firebase from '@/fb'; 
import moment from 'moment';
import fbAdmin from 'firebase';

export default class UserDataService {

    async searchFirebaseByUserId(id){
        return new Promise(function(resolve, reject){
            //Will get the document based on the userID, a query will have to be done for this
            var docRef = firebase.db.collection('users').where("uid", "==", id);
            
            docRef.get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    // doc.data() is never undefined for query doc snapshots
                    const data = {
                      uid: doc.data().uid,
                      displayname: doc.data().displayname,
                      firstname: doc.data().firstname,
                      surname: doc.data().surname,
                      photo: doc.data().photo,
                      email: doc.data().email,
                      treatments: doc.data().treatments,
                      orgid: doc.data().orgid,
                      orgadmin: doc.data().orgadmin,
                      interests: doc.data().interests,
                      location: doc.data().location,
                      online: doc.data().online,
                      activity: doc.data().activity,
                      premium: doc.data().premium,
                      faveTreatments: doc.data().faveTreatments,
                      faveCases: doc.data().faveCases
                    }
                    resolve(data);
                });
              })
              .catch(function(error) {
                  reject(error);
              });
        })   
    }

    async setUserStatusOnline(id){
        return new Promise(function (resolve, reject){
            //Will get the document based on the userID, a query will have to be done for this
            var docRef = firebase.db.collection('users').where("uid", "==", id);

            docRef.get().then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    //Laziliy get the true id based on the uid at the moment, just in case there are any discrepencies
                    var uid = doc.id;

                    // Set the specific user's online status to true
                    docRef
                    .doc(uid)
                    .set({
                        online: {
                            status: true,
                            lastSeen: moment()
                        },
                    }, { merge: true })
                    .then(function() {
                        resolve("Success");
                    })
                    .catch(function(error) {
                        reject(error);
                    });
                });
            });
        });
    }

    async searchFirebaseByUserIdList(ids){
        var that = this;
        return new Promise(function(resolve, reject){
            //"in" may be limited to 10 returns, so instead we do multiple searchFirebaseByUserId calls
            var userList= [];
            ids.forEach(function(id){
                that.searchFirebaseByUserId(id)
                .then(function(returnedUser){
                    if (returnedUser !== null){
                        userList.push(returnedUser);
                        if(userList.length === ids.length){
                            //Once our userList is populated, we can then return the whole list
                            resolve(userList); 
                        }
                    } else {
                        reject("Invalid user returned!");
                    }
                })
                .catch(function(error){
                    reject(error);
                })
            });           
        })   
    }

    async getUserDocID(uid){
        return new Promise(function(resolve, reject){
            var docRef = firebase.db.collection('users').where("uid", "==", uid);
            
            docRef.get()
            .then(function(querySnapshot) {
                querySnapshot.forEach(function(doc) {
                    if (doc.exists) {
                        resolve(doc.id);
                    } else {
                        resolve(null);
                    }
                });
            })
            .catch(function(error){
                reject(error);
            });
        });
    }

    async updateUserById(uid, updateObject){
        var that = this;
        return new Promise(function(resolve, reject){
            if (uid){
                that.getUserDocID(uid)
                .then(function(id){
                    firebase.db
                    .collection('users')
                    .doc(id)
                    .update(updateObject)
                    .then(function(){
                        resolve("User Details Successfully updated");
                    })
                    .catch(function(error){
                        reject("Error updating the user details: " + error);
                    })
                }).catch(function(error){
                    reject("Error getting the userID: " + error);
                })
            } else {
                reject("No User ID entered");
            }

            
        });
    }

    async addUserToOrganisation(org, existing, userDetails){
        return new Promise(function(resolve, reject){
            //existing checks for whether we are creating a new user or adding an existing one
            if (existing == false){
                //If not, check that the organisation has no gone past/doesn't equal its maxUser quota
                if (org.users.length >= org.maxUsers) {
                    //Cannot add a new user because already at maximum quota
                    reject("Cannot add new user because already at max quota, please contact your system administrator");
                } else {
                    //Get function reference
                    const createNewUser = firebase.functions.httpsCallable('createNewUser');
                    createNewUser(userDetails)
                    .then(function(result){
                        if (result.data === "Success"){
                            resolve(result.data);
                        }
                        reject(result.data); 
                        //On success we could start a listener on that userId
                        //If the new userId exists, we can unsubscribe from the listener and then call addExistingUser cloud function? NEED A FUTURE CALL FOR THIS
                    })
                    .catch(function(error){
                        reject(error);
                    });
                }
                //New 'users' document is created with the cloud function, and soon the email set password link will be sent from here as well 

                //Once this is all complete we'd have to the new user as though they were an existing (How?) --> with a client side function?
            } else {
                //If we are adding an existing one, then the newUserDetails will just = id
                console.log("Adding an existing user (email): " + userDetails.email); //eslint-disable-line
                userDetails.orgid = org.id; //Update our userDetails object to include the orgId

                //Get function reference
                const addExistingUser = firebase.functions.httpsCallable('addExistingUser');
                addExistingUser(userDetails)
                .then(function(result){
                    if (result.data === "Success"){
                        resolve(result.data);
                    }
                    reject(result.data); 
                })
                .catch(function(error){
                    reject(error);
                });
            }
        });
    }

    async removeUserFromOrganisation(org, userDetails) {
        //Eventually, it may be required to add audit information on who removed the user and 'why'
        return new Promise(function(resolve, reject){
            if (org.users.length == 1) {
                //Cannot add a new user because already at maximum quota
                reject("Cannot remove another user (at least 1 user must be in the organisation), please contact support if you wish to close this organisation");
            } else {
                //Get function reference
                const removeUser = firebase.functions.httpsCallable('removeUserFromOrganisation');
                removeUser(userDetails)
                .then(function(result){
                    if (result.data === "Success"){
                        resolve(result.data);
                    }
                    reject(result.data); 
                    //On success we could start a listener on that userId, to modify the user organisation information
                })
                .catch(function(error){
                    reject(error);
                });
            }
        });
    }

    uploadUserPhotoById(uid, photo){
        var that = this;
        return new Promise(function(resolve, reject){
            //First Validate the photo based on size (in the future we may add a profanity check using something like this: https://nsfwjs.com/) 
            const valid = that.validatePhoto(photo);
            if (valid === true){
                //If Valid: Upload the image to the firebase storage
                var imageStorageRef = firebase.storage.ref().child(`images/users/${uid}/`)
                //Save image to cloud storage
                imageStorageRef
                .put(photo)
                .then(() => {
                    console.log("Successfully Saved Image to Cloud Storage"); // eslint-disable-line no-console
                    //Then get the Image URL
                    imageStorageRef
                    .getDownloadURL()
                    .then((imageURL) => {
                        //If successful: Take this reference and updateUserById
                        const updateObject = {photo: imageURL};
                        that.updateUserById(uid, updateObject)
                        .then((result) => {
                            resolve(result);
                        })
                        .catch((error) => {
                            reject(error);
                        })
                    });
                })
                .catch((error) => {
                    //If fail: return error
                    reject(error);
                });
            } else {            
                //If Invalid: return error
                reject(valid.error);
            }
        });
    }

    async favourite(uid, id, isCase) {
        var that = this;
        return new Promise(function(resolve, reject){
            const term = (isCase === true) ? "Case" : "Treatment";
            if (!id) {
                reject(`No ${term} Id`); 
            }
            
            try {
                //Check if favourited
                that.checkIfFavourited(uid, id, isCase)
                .then((isFavourited) => {
                    //Escape early if it has already been favourited
                    if (isFavourited) {
                        reject(`The current ${term} is already favourited`);
                    }

                    if (!isCase) {
                        //If the user wishes to favourite a treatment
                        const updateObject = { faveTreatments: fbAdmin.firestore.FieldValue.arrayUnion(id) };
    
                        //Use that updateObject to add in the new favourite treatment
                        const result = that.updateUserById(uid, updateObject);
                        resolve(result);
                    } else {
                        //If the user wishes to favourite a case
                        const updateObject = { faveCases: fbAdmin.firestore.FieldValue.arrayUnion(id) };
    
                        //Use that updateObject to add in the new favourite treatment
                        const result = that.updateUserById(uid, updateObject);
                        resolve(result);
                    }          
                })
                .catch((error) => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    async unfavourite(uid, id, isCase) {
        var that = this;
        return new Promise(function(resolve, reject){
            const term = (isCase === true) ? "Case" : "Treatment";
            if (!id) {
                reject(`No ${term} Id`); 
            }
            
            try {
                 //Check if favourited
                 that.checkIfFavourited(uid, id, isCase)
                 .then((isFavourited) => {
                    //Escape early if it has already been unfavourited
                    if (!isFavourited) {
                        reject(`The current ${term} is not currently favourited`);
                    }

                    if (!isCase) {
                        //If the user wishes to unfavourite a treatment
                        const updateObject = { faveTreatments: fbAdmin.firestore.FieldValue.arrayRemove(id) };
    
                        //Use that updateObject to add in the new favourite treatment
                        const result = that.updateUserById(uid, updateObject);
                        resolve(result);
                    } else {
                        //If the user wishes to unfavourite a case
                        const updateObject = { faveCases: fbAdmin.firestore.FieldValue.arrayRemove(id) };
    
                        //Use that updateObject to add in the new favourite treatment
                        const result = that.updateUserById(uid, updateObject);
                        resolve(result);
                    }          
                 })
                 .catch((error) => {
                    reject(error);
                 });
            } catch (error) {
                reject(error);
            }
        });
    }

    checkIfFavourited(uid, id, isCase) {
        var that = this;
        return new Promise(function(resolve, reject){
            //Get the userDb
            that.searchFirebaseByUserId(uid)
            .then((user) => {
                if (!user) {
                    reject("Cannot find user");
                }
        
                if (!isCase) {
                    //Check the treatment favourites list
                    if (!user.faveTreatments) {
                        resolve(false);
                    }

                    resolve(user.faveTreatments.includes(id));
                } else {
                    //Check the case favourites list
                    if (!user.faveCases) {
                        resolve(false);
                    }

                    resolve(user.faveCases.includes(id));
                }
            })
            .catch((error) => {
                reject("Error getting user: ", error);
            });        
        });
    }

    validatePhoto(file){
        if (file.size > 5e6){
            return {valid: false, error: "File size too large!"};
        } else if (file.name.lastIndexOf(".") <= 0){
            return {valid: false, error: "Invalid file type!"};
        }
        return true;
    }
}